<script>
  export default {
    props: {
      message: {
        type: Object,
        required: true
      }
    },
    render: function (createElement) {
      return createElement('div', { 
          class: [
            'sc-message--system',
            this.messageClass 
          ],
          attrs: {
            id: this.message.id
          },
          domProps: {
            innerHTML: this.safeTextWithEmoji(this.systemMessage)
          }
        }
      )
    },
    computed: {
      systemMessage: function() {
        if (this.message.type == this.types.TimerMessage) {
          if (this.message.data.ttl > 0) {
            if (this.message.sent)
              return this.$t('chat_timer_info_by_yourself', [this.getTimerString(this.message.data.ttl)])
            else
              return this.$t('chat_timer_info', [this.message.authorName, this.getTimerString(this.message.data.ttl)])
          }
          else {
            if (this.message.sent)
              return this.$t('chat_timer_info_cancel_by_yourself')
            else
              return this.$t('chat_timer_info_cancel', [this.message.authorName])
          }
        }
        else if (this.message.type == this.types.DateMessage) {
          return this.message.message
        }
        else if (this.message.type == this.types.UserAddedMessage) {
          let users = ""
          let userIds = this.message.content.split("\n")
          userIds.forEach(userId => {
            if (users!="")
              users += ", "
            users += this.$store.getters.getContactName(userId)
          })
          if (this.message.sent)
            return this.$t('chat_user_added_yourself',[users])
          else
            return this.$t('chat_menu_add_users_sys_msg', [this.message.authorName, users]) 
        }
        else if (this.message.type == this.types.UserLeftMessage) {
          return this.$t('chat_menu_leave_chat_sys_msg', [this.message.authorName]) 
        }
        else if (this.message.type == this.types.ChatDetailsMessage) {
          if (this.message.data.notificationType == 0) {
            if (this.message.sent)
              return this.$t('chat_title_changed_yourself', [this.message.data.chatTitle])
            else
              return this.$t('chat_title_changed', [this.message.authorName, this.message.data.chatTitle])
          } else {
            if (this.message.sent)
              return this.$t('chat_image_changed_yourself')
            else
              return this.$t('chat_image_changed', [this.message.authorName])
          }
        }
        return ''
      },
      messageClass() {
        return (this.message.type == this.types.DateMessage) ? 'date' : 'event'
      }
    }
  }
</script>

<style>
  .sc-message--system {
    white-space: pre-wrap;
    -webkit-font-smoothing: subpixel-antialiased;
    user-select: none;
  }
  .sc-message--system.date {
    font-size: 85%;
    line-height: 1.2;
    margin: 24px 0;
    font-weight: 300;
    opacity: .85;
    background-color:var(--date-message-background);
    padding: 8px 16px;
    border-radius:16px;
  }
  .sc-message--system.event {
    margin: 4px 0;
    font-size: 95%;
  }
</style>
